<template>
  <div class="p-4">
    <section v-if="props.error?.statusCode === 404">
      <div class="l-inner">
        <section class="section-area my-10 break-words md:my-20">
          <div class="title-area">
            <h1 class="text-[170px] md:mb-8">404</h1>
            <h2>Page not Found</h2>
          </div>
          <hr class="md:w-[325px]" />
          <div class="mx-auto max-w-[588px] text-center">
            <p>
              We apologize for the inconvenience.<br />
              The page you're looking for might have been removed, renamed, or is temporarily unavailable. <br />
              Please return to the homepage or click the link below.
            </p>
            <AtomsSecondaryButton class="mt-4 max-w-[368px]" :on-click="onClickReload">
              <span>Refresh this page</span>
            </AtomsSecondaryButton>
          </div>
        </section>
      </div>
    </section>
    <section v-else>
      <AtomsHeading1 class="mb-4 text-center">{{ props.error?.statusCode }} Error</AtomsHeading1>
      <div class="error_content">
        <!-- eslint-disable-next-line vue/no-v-html -->
        <p v-if="props.error?.statusCode === 400 && props.error?.message" class="mb-10 text-sm tracking-[1px] text-black1 md:text-base" v-html="props.error?.message" />
        <AtomsParagraph v-else class="mb-10">An error has occurred.<br />Please wait a few minutes and then access the site again.</AtomsParagraph>
        <div class="">
          <AtomsTertiaryButton class="w-full" :on-click="onClickReturnButton">
            <span>Return to TOP page</span>
          </AtomsTertiaryButton>
        </div>
      </div>
    </section>
  </div>
</template>
<script setup lang="ts">
// eslint-disable-next-line vue/require-default-prop
const props = defineProps({ error: Object });
const onClickReturnButton = () => clearError({ redirect: '/' });
const onClickReload = () => {
  reloadNuxtApp();
};
</script>
<style scoped lang="scss">
.error_content {
  max-width: 588px;
  margin: 0 auto;
}
.l-inner {
  padding: 16px;
}

.section-area {
  color: #333;
  font-family: Playfair Display;
  display: flex;
  flex-direction: column;
  row-gap: 2.5rem;
}

.title-area {
  display: flex;
  flex-direction: column;
  align-items: center;
  h1 {
    margin-bottom: 1rem;
  }

  h2 {
    margin-bottom: 0.5rem;
  }
}

h1 {
  font-size: 124px;
  line-height: 170px;
  text-align: center;
  margin-bottom: 1rem;
}

h2 {
  font-size: 28px;
  line-height: 18px;
  letter-spacing: 0px;
  text-align: center;
}

p {
  font-size: 0.875rem;
  line-height: 1.5rem;
  text-align: center;
}

hr {
  border: none;
  border-top: 1px solid #333;
  width: 120px;
  margin: 0 auto;
}
</style>
